import { isDark } from '..'
import * as Sentry from '@sentry/react'
import { useEventEmitter } from '../EventEmitter'
import { useProfileQuery, ProfileQuery } from './Profile.generated'
import { createContext, useContext, useEffect, ReactNode } from 'react'

export type ProfileType = ProfileQuery['Profile']

const ProfileCtx = createContext<ProfileType>(null)

export function useProfile() {
  return useContext(ProfileCtx)
}

export function ProfileProvider({ children }: { children: ReactNode }) {
  const eventEmitter = useEventEmitter()
  const { data, error } = useProfileQuery()

  useEffect(() => {
    if (data?.Profile) {
      const style = document.documentElement.style
      const { foreground, background, headerTextColor } = data.Profile

      style.setProperty('--foreground', foreground)
      style.setProperty('--background', background.color)
      style.setProperty(
        '--foreground-text',
        isDark(background.background) ? 'white' : foreground
      )
      style.setProperty('--background-text', headerTextColor)
      eventEmitter.emit('____app_ready')
    }
  }, [data?.Profile, eventEmitter])

  if (error) {
    Sentry.captureException(error)
  }

  if (data?.Profile)
    return (
      <ProfileCtx.Provider value={data?.Profile}>
        {children}
      </ProfileCtx.Provider>
    )

  return null
}
